export const versionConfig = {
  version: "1.0.21",
  buildDate: "2026-03-23",
  changelog: `
    - Added Original Recipe reference panel to the Production LOT Finalization page. Click the collapsible "Original Recipe" card to view the full ingredient list with images, GTINs, quantities, and waste percentages without leaving the finalization workflow. A direct link to the recipe detail page is also available in the card header.
    - PO Price column added to the Receive Vendor Shipment table
  `,
  showNotification: false,
  forceReset: false,
  softReset: false
}

// Backward compatibility exports
export const version = versionConfig.version
export const buildDate = versionConfig.buildDate
